import videojs from 'video.js'

import { facebook_share_link, linkedin_share_link, twitter_share_link } from '../../../utils'

const ClickableComponent = videojs.getComponent('ClickableComponent')
const Component = videojs.getComponent('Component')

class SocialShareButton extends ClickableComponent {
  buildCSSClass() {
    return `vjs-social-share-button vjs-social-share-${this.options_.type}`
  }

  handleClick() {
    switch (this.options_.type) {
      case 'facebook':
        window.open(facebook_share_link(this.options_.url), '_blank')
        break
      case 'twitter':
        window.open(twitter_share_link(this.options_.title, this.options_.url), '_blank')
        break
      case 'linkedin':
        window.open(linkedin_share_link(this.options_.url), '_blank')
        break
    }
  }
}

class SocialShareButtons extends Component {
  constructor(player, options) {
    super(player, options)
    this.addClass('vjs-social-share-buttons')
    this.addChild('SocialShareButton', { type: 'facebook', ...options })
    this.addChild('SocialShareButton', { type: 'twitter', ...options })
    this.addChild('SocialShareButton', { type: 'linkedin', ...options })
    this.addChild('CloseSocialShareButton', {})
  }
}

class CloseSocialShareButton extends ClickableComponent {
  constructor(player, options) {
    super(player, options)
    this.controlText('×')
  }

  buildCSSClass() {
    return 'vjs-social-share-close-button'
  }

  handleClick() {
    this.player_.getChild('SocialShareButtons').hide()
  }
}

function onPlayerReady(player, options) {
  player.addChild('SocialShareButtons', options)
}

export default function socialSharePlugin(options) {
  videojs.registerComponent('SocialShareButton', SocialShareButton)
  videojs.registerComponent('SocialShareButtons', SocialShareButtons)
  videojs.registerComponent('CloseSocialShareButton', CloseSocialShareButton)

  this.ready(() => {
    onPlayerReady(this, options)
  })
}
